import * as React from 'react';
import { Link } from 'react-router-dom';
import { UitkHeading } from 'uitk-react-text';

export interface RoomComponentDesktopProps {
  roomCount: any;
  childComponent: any;
}
export class RoomComponentDesktop extends React.Component<RoomComponentDesktopProps, any> {
  public constructor(props) {
    super(props);
  }

  public render() {
    const { roomCount } = this.props;

    return (
      <>
        <div className="uitk-cell" />
        <div className="uitk-cell" />
        <div className="uitk-cell">{this.props.childComponent}</div>
      </>
    );
  }
}
